import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fc08587"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-full bg-white",
  style: {"background":"rgba(0, 0, 0, 0.6)"}
}
const _hoisted_2 = { class: "home-container px-2 md:px-0 h-12 flex items-center justify-between" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "r-header hidden md:block w-100 h-100 md:w-80" }
const _hoisted_5 = { class: "flex w-100 items-center justify-around text-sm text-gray-600" }
const _hoisted_6 = { class: "jc-dropdown p-2 cursor-pointer focus:text-blue-500 relative" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产品中心", -1))
const _hoisted_8 = { class: "down-menu flex flex-col relative py-2 pt-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("g", { fill: "none" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2 4.25a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.25zm0 4a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 8.25zm0 4a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75z",
      fill: "currentColor"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_dropdown = _resolveComponent("n-dropdown")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "hidden md:block md:h-auto md:w-44",
        src: require('../../assets/logo.png'),
        alt: "...",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ path: '/' })))
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "p-2 cursor-pointer focus:text-white-500",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ path: '/' })))
          }, "首页"),
          _createElementVNode("button", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "down-menu-item h-10 block text-gray-500 hover:bg-gray-100",
                style: {"line-height":"2.5rem"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ path: '/kaixinhu' })))
              }, " 开心虎 "),
              _createElementVNode("div", {
                class: "down-menu-item h-10 block text-gray-500 hover:bg-gray-100",
                style: {"line-height":"2.5rem"},
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ path: '/yibeiduo' })))
              }, " 益贝多 "),
              _createElementVNode("div", {
                class: "down-menu-item h-10 block text-gray-500 hover:bg-gray-100",
                style: {"line-height":"2.5rem"},
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ path: '/meishiyouxiang' })))
              }, " 每食优享 "),
              _createElementVNode("div", {
                class: "down-menu-item h-10 block text-gray-500 hover:bg-gray-100",
                style: {"line-height":"2.5rem"},
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ path: '/kaixinhugongchangduan' })))
              }, " 开心虎管理 ")
            ])
          ]),
          _createElementVNode("button", {
            class: "p-2 cursor-pointer",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({ path: '/about' })))
          }, "关于我们")
        ])
      ]),
      _createElementVNode("div", {
        class: "phone-logo w-10 h-10 md:hidden",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({ path: '/' })))
      }),
      _createVNode(_component_n_dropdown, {
        class: "md:hidden",
        onSelect: _ctx.handleSelect,
        trigger: "hover",
        options: _ctx.options
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            type: "info",
            ghost: "",
            class: "md:hidden"
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_n_icon, null, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSelect", "options"])
    ])
  ]))
}